/**
 * Eigen wachtwoord wijzigen — voor elke rol, ook een chatter zonder Settings.
 *
 * 26-09-2026 (Era kon haar wachtwoord niet zelf wijzigen). De route
 * `auth/change-password` bestond al, maar het nieuwe dashboard riep hem
 * nergens aan.
 */
import { useState } from 'react'
import { Field, Modal } from './Modal'
import { useActions } from '../lib/actions'
import { api, setToken } from '../lib/api'

const LEEG = { huidig: '', nieuw: '', herhaal: '' }

export function WachtwoordWijzigen({ onClose }: { onClose: () => void }) {
  const { run, busy } = useActions()
  const [f, setF] = useState(LEEG)

  const probleem = !f.huidig || !f.nieuw
    ? ''
    : f.nieuw.length < 8
      ? 'The new password needs at least 8 characters.'
      : f.nieuw !== f.herhaal
        ? 'The two new passwords do not match.'
        : ''
  const klaar = !!f.huidig && f.nieuw.length >= 8 && f.nieuw === f.herhaal

  return (
    <Modal
      title="Change password"
      width={420}
      onClose={onClose}
      footer={
        <>
          <button className="btn ghost" type="button" onClick={onClose}>Cancel</button>
          <button
            className="btn primary"
            type="button"
            disabled={!klaar || busy === 'Change password'}
            onClick={async () => {
              const gelukt = await run({
                label: 'Change password',
                // 03-10-2026: een nieuw wachtwoord beëindigt elke sessie; deze
                // krijgt een vers token terug en blijft dus ingelogd.
                request: async () => {
                  const d = await api.post<{ access_token?: string }>('/api/admin/auth/change-password', {
                    current_password: f.huidig,
                    new_password: f.nieuw,
                  })
                  if (d?.access_token) setToken(d.access_token)
                  return d
                },
                successText: 'Password changed',
              })
              // Bij een fout blijft het venster open, met de melding als toast.
              if (gelukt) onClose()
            }}
          >
            Save
          </button>
        </>
      }
    >
      <Field label="Current password">
        <input className="inp" type="password" autoComplete="current-password"
               value={f.huidig}
               onChange={(e) => setF((x) => ({ ...x, huidig: e.target.value }))} />
      </Field>
      <Field label="New password" hint="At least 8 characters.">
        <input className="inp" type="password" autoComplete="new-password"
               value={f.nieuw}
               onChange={(e) => setF((x) => ({ ...x, nieuw: e.target.value }))} />
      </Field>
      <Field label="Repeat new password">
        <input className="inp" type="password" autoComplete="new-password"
               value={f.herhaal}
               onChange={(e) => setF((x) => ({ ...x, herhaal: e.target.value }))} />
      </Field>
      {probleem ? <div className="mut2" style={{ color: '#fca5a5', fontSize: 12 }}>{probleem}</div> : null}
    </Modal>
  )
}
